import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Box, Price } from '@yonderland/andes-react';
import { usePriceProps } from '../../../hooks/usePriceProps';
export const MiniPDPPrice = ({ color, selectedSize, isOutOfStock }) => {
    const { feature_toggles: { lowest_price_all }, } = useAemConfig();
    const prices = (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.prices) || color.prices;
    const priceProps = usePriceProps({
        priceInformation: {
            prices,
            hasDiscount: color.hasDiscount,
        },
        dynamicSavingsInformation: {
            productDiscountAmount: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productDiscountAmount) || color.price.productDiscountAmount,
            productDiscountPercentage: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productDiscountPercentage) || color.price.productDiscountPercentage,
        },
        enablePriceReference: lowest_price_all,
    });
    if (!priceProps) {
        return null;
    }
    return (_jsx(Box, { paddingBlockStart: "4", opacity: isOutOfStock ? '50' : undefined, children: _jsx(Price, Object.assign({}, priceProps, { size: "lg" })) }));
};
